import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import { useSingleCache } from '@/data/hook/query/v2/useCacheManager';
import { lessonBlocksQueryKeys } from '@/data/services/querykeys';
import Unit from '@/models/Unit';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

const useUnitWorkspace = () => {
  const {
    courseLineId: courseLineParam,
    moduleId: moduleParam,
    slug,
    unitId: unitParam,
  } = useParams();

  const courseLineId = Number(courseLineParam);
  const moduleId = Number(moduleParam);
  const unitId = Number(unitParam);

  const unitQueryKey = lessonBlocksQueryKeys.get(slug ?? '', unitId);

  const { data: unit, isInitialLoading } = useQuery({
    ...unitQueryKey,
    enabled: !!slug && !!unitId,
    staleTime: REQUEST_STALE_TIME_IN_MS,
  });

  const cache = useSingleCache<Unit>(unitQueryKey.queryKey);

  const isLoading = isInitialLoading && !!slug && !!unitId;

  return {
    unit,
    slug,
    courseLineId,
    moduleId,
    unitId,
    isLoading,
    cache,
  };
};

export default useUnitWorkspace;
